import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  breaks: true,
});

const MarkdownPrototypes = {
  install(Vue) {
    Object.defineProperties(Vue.prototype, { _markdown: { get() { return md; } } });
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(MarkdownPrototypes);
    }
  },
};

export default MarkdownPrototypes;



// WEBPACK FOOTER //
// ./src/init/markdown-prototypes.js